import { render, staticRenderFns } from "./PopupAppRelease.vue?vue&type=template&id=f058d7b6"
import script from "./PopupAppRelease.vue?vue&type=script&lang=js"
export * from "./PopupAppRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports